import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { ordersRepository } from '../../../modules/orders/repositories/ordersRepository/orders.repository';
import { GeneralSettingsParams } from '../../../stores/GeneralSettings/generalSettings.types';
import { getFindBrandGeneralSettingsKey } from './brandGeneralSettings.keys';
import { UseFindBrandGeneralSettingsParams } from './brandGeneralSettings.types';

export const useFindBrandGeneralSettings = ({
  onSuccess,
  options: { teamId, ...options },
}: UseFindBrandGeneralSettingsParams) =>
  useDataQuery<GeneralSettingsParams | null>(
    {
      queryKey: getFindBrandGeneralSettingsKey(),
      teamId,
      queryFn: async () => {
        const repository = ordersRepository();
        const data = await repository.getBrandSettings();
        if (!data.ok || !data.data) {
          return null;
        }

        if (onSuccess) {
          onSuccess(data.data);
        }
        return data.data;
      },
    },
    options,
  );
